type EnvRecord = Record<string, string | undefined>;

function getMetaEnv(): EnvRecord {
  if (typeof import.meta !== 'undefined' && (import.meta as any)?.env) {
    return (import.meta as any).env as EnvRecord;
  }
  return {};
}

export function readRuntimeEnv(name: string): string | undefined {
  if (typeof process !== 'undefined' && process.env && process.env[name]) {
    return process.env[name];
  }
  const metaEnv = getMetaEnv();
  const value = metaEnv[name];
  if (typeof value === 'string' && value.length > 0) return value;
  return undefined;
}

export function isPreviewRuntime(): boolean {
  const taggedEnv = (readRuntimeEnv('NEXT_PUBLIC_ENV') || readRuntimeEnv('VITE_APP_ENV') || '').toLowerCase();
  const vercelEnv = (readRuntimeEnv('VERCEL_ENV') || '').toLowerCase();
  return taggedEnv === 'preview' || vercelEnv === 'preview';
}

function normaliseOrigin(value: string): string {
  if (!value) return value;
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
}

export function resolveRuntimeOrigin(): string | null {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  const vercelUrl = readRuntimeEnv('VERCEL_URL');
  if (vercelUrl) {
    return normaliseOrigin(vercelUrl);
  }

  if (isPreviewRuntime()) {
    const fallback = readRuntimeEnv('NEXT_PUBLIC_PREVIEW_ORIGIN') || 'localhost:3000';
    return normaliseOrigin(fallback);
  }

  return null;
}
